import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export interface AccessInformation {
  ip: string | string[] | undefined;
  userAgent: string | string[] | undefined;
}

const BaseAuditLogSchema = z.object({
  _id: zExt.objectId(),
  type: z.string(),
  team: zExt.objectId().optional(),
  user: z.string().optional(),
  userId: zExt.objectId().optional(),
  Resource: z.string().optional(),
  access: z.any().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const SettingsAuditLogSchema = BaseAuditLogSchema.extend({
  type: z.literal("setting"),
  path: z.string().optional(),
  prev: z.any().optional(),
  next: z.any().optional(),
});

export type SettingsAuditLog = z.infer<typeof SettingsAuditLogSchema>;

export enum TexasSegmentRemovalDocumentType {
  CAMPAIGN = "campaign",
  AUTOMATION = "automation",
}
const texasSegmentRemovalAuditLogSchema = BaseAuditLogSchema.extend({
  type: z.literal("texasSegmentRemoval"),
  documentType: createEnum(TexasSegmentRemovalDocumentType),
  documentId: zExt.objectId(),
});

export const AuditLogSchema = z.discriminatedUnion("type", [
  SettingsAuditLogSchema,
  texasSegmentRemovalAuditLogSchema,
]);
export type AuditLog = z.infer<typeof AuditLogSchema>;
